export default __webpack_public_path__ + "static/help_06_05_1-6c33c3c025987a3ffd4fae01056c794a.png";